import { companyAwaitReducer } from "../reducer/CompanyAwaitReducer";

export const reducer = companyAwaitReducer;
